import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import FireIcon from '../../assets/icone/header/iconaFuocoOut.svg';
import TrainIcon from '../../assets/icone/header/iconaTreniOut.svg';
import FlightIcon from '../../assets/icone/header/iconaAereiOut.svg';
import RoomIcon from '../../assets/icone/header/iconaAlloggiOut.svg';
import LanguageSwitcher from '../../utils/LenguageSwitcher';
import FireColored from '../../assets/icone/header/iconOccasionsColored.svg';
import FlightColored from '../../assets/icone/header/iconAirplaneColored.svg';
import TrainColored from '../../assets/icone/header/iconTrainColored.svg';
import RoomColored from '../../assets/icone/header/iconRoomColored.svg';

const HeaderMobile = () => {
    const { t } = useTranslation();
    const [clicked, setClicked] = React.useState('');
    const navigate = useNavigate();
    const location = useLocation();

    // Funzione per gestire la selezione dell'icona e la navigazione
    const handleButtonClick = (newCategory) => {
        setClicked(newCategory);
        switch (newCategory) {
            case 'fire':
                navigate('/');
                break;
            case 'train':
                navigate('/trainTicket');
                break;
            case 'flight':
                navigate('/flightTicket');
                break;
            case 'room':
                navigate('/roomTicket');
                break;
            default:
                break;
        }
    };

    // Funzione per determinare l'icona della categoria
    const getCategoryIcon = (category) => {
        const iconStyle = 'w-6 h-6'; // Dimensione fissa per tutte le icone
        const isActive = clicked === category;

        let iconSrc;
        switch (category) {
            case 'fire':
                iconSrc = isActive ? FireColored : FireIcon;
                break;
            case 'train':
                iconSrc = isActive ? TrainColored : TrainIcon;
                break;
            case 'room':
                iconSrc = isActive ? RoomColored : RoomIcon;
                break;
            case 'flight':
                iconSrc = isActive ? FlightColored : FlightIcon;
                break;
            default:
                iconSrc = null;
        }

        return (
            <div className={iconStyle}>
                <img src={iconSrc} alt={`${category} Icon`} className="w-full h-full" />
            </div>
        );
    };

    // Aggiorna la categoria cliccata in base al percorso attuale
    useEffect(() => {
        const path = location.pathname;
        if (path === '/') {
            setClicked('fire');
        } else if (path.includes('experience')) {
            setClicked('fire');
        } else if (path.includes('train')) {
            setClicked('train');
        } else if (path.includes('flight')) {
            setClicked('flight');
        } else if (path.includes('room')) {
            setClicked('room');
        }
    }, [location]);

    return (
        <div className="w-full bg-white px-4 py-4 border-b border-gray-300 fixed top-0 z-40">
            {/* Prima linea: Titolo e Icone */}
            <div className="flex items-center justify-between">
                {/* Titolo */}
                <div className="font-heading font-bold text-2xl">SAVE YOUR TRAVEL</div>

                {/* Icone: Search e Language */}
                <div className="flex items-center space-x-4">
                    <LanguageSwitcher />
                </div>
            </div>

            {/* Seconda linea: Icone delle categorie */}
            <div className="flex justify-around mt-4">
                {['fire',  'room', 'train', 'flight'].map((item) => (
                    <button
                        key={item}
                        onClick={() => handleButtonClick(item)}
                        className={`text-sm font-heading font-semibold uppercase flex items-center justify-center space-x-1 ${clicked === item ? 'text-black' : 'text-gray-500'} ${clicked === item ? 'animate-press' : ''}`}
                    >
                        {getCategoryIcon(item)}
                        <span>{t(`search.${item}`)}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default HeaderMobile;
